import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Home.vue")
  },{
    path: "/live",
    name: "live",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Live.vue")
  },{
    path: "/share",
    name: "share",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Share.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
